jQuery(document).ready(function () {
  const sliders = document.querySelectorAll('.main-image-slider');
  const variantButtons = document.querySelectorAll(
    '.variant__input__color__item',
  );
  // console.log(variantButtons);

  // check if sliders is an array and has more than 0 items
  if (sliders !== null && sliders.length > 0) {
    sliders.forEach(function (slider, index) {
      jQuery(slider).slick({
        autoplay: false,
        dots: true,
        arrows: true,
        arrowsPlacement: 'beforeSlides',
        prevArrow:
          '<button type="button" class="custom-prev-button btn">' +
          '  <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512" aria-hidden="true"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M2.7 256l22.6 22.6 192 192L240 493.3 285.3 448l-22.6-22.6L93.3 256 262.6 86.6 285.3 64 240 18.7 217.4 41.4l-192 192L2.7 256z"/></svg>' +
          '  <span class="visually-hidden">Previous photo</span>' +
          '</button>',
        nextArrow:
          '<button type="button" class="custom-next-button btn">' +
          '  <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512" aria-hidden="true"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M317.3 256l-22.6 22.6-192 192L80 493.3 34.7 448l22.6-22.6L226.7 256 57.4 86.6 34.7 64 80 18.7l22.6 22.6 192 192L317.3 256z"/></svg>' +
          '  <span class="visually-hidden">Next photo</span>' +
          '</button>',
      });

      if (variantButtons !== null && variantButtons.length > 0 && index === 0) {
        variantButtons.forEach(function (button, variantIndex) {
          button.addEventListener('change', function (e) {
            jQuery(slider).slick('slickGoTo', variantIndex);
          });
        });
      }
    });
  }
});
